import { cn, createComponent } from '@lair-finance/util'
import { ButtonHTMLAttributes, HTMLAttributes } from 'react'
import { SERVICE_LINKS } from '@lair-finance/config'

export const AgreeCheckButton = createComponent<HTMLDivElement, HTMLAttributes<HTMLDivElement> & { checked?: boolean; onCheck?: () => void }>(
  ({ checked, onCheck, className, ...props }, ref) => (
    <div className={cn('flex items-center', className)} ref={ref} {...props}>
      <CheckBox className={'mr-3'} checked={checked} onClick={onCheck} />
      <span className={'typo-caption-2 sm:typo-caption-1 text-greyscale-100 [&>a]:text-palette-sky [&>a]:underline'}>
        I have read and agreed to the{' '}
        <a href={SERVICE_LINKS.TERMS} target={'_blank'}>
          terms of use
        </a>{' '}
        and the{' '}
        <a href={SERVICE_LINKS.PRIVACY} target={'_blank'}>
          privacy policy.
        </a>
      </span>
    </div>
  ),
  'AgreeCheckButton',
)

const CheckBox = createComponent<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement> & { checked?: boolean }>(
  ({ className, checked, ...props }, ref) => (
    <button
      className={cn(
        'flex-shrink-0 inline-flex-center rounded-[4px] size-6',
        {
          'bg-[url(/static/icons/checkbox.png)] bg-center bg-no-repeat bg-contain': checked,
          'border border-greyscale-300': !checked,
        },
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
  'CheckBox',
)
